// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledSection404 = styled.div`padding: 40px;`;

const Section404 = () => {
    return (
        <StyledSection404>
            <h3>404 - Section Not Found</h3>
            <p>
                <Link to="/">Click here</Link> to go home.
            </p>
        </StyledSection404>
    );
};

export default Section404;



// WEBPACK FOOTER //
// ./src/components/shared/Section404.js